type GroupByKey<K> = K extends string | number | symbol ? K : string
export function groupBy<K, T>(items: T[], keySelector: (t: T) => K): Record<GroupByKey<K>, T[]> {
  const result = {} as Record<GroupByKey<K>, T[]>
  for (const item of items) {
    const key = keySelector(item) as GroupByKey<K>
    if (!result[key]) {
      result[key] = []
    }
    result[key].push(item)
  }

  return result
}

export const sum = <T>(items: T[], fn: (n: T) => number): number => {
  return items.reduce((acc, x) => acc + fn(x), 0)
}

export const updateAtIndex = <T>(items: T[], index: number, updater: (x: T) => T): T[] => {
  return items.map((x, i) => i === index ? updater(x) : x)
}

export const updateWhere = <T>(items: T[], predicate: (t: T) => boolean, updater: (t: T) => T): T[] => {
  return items.map(x => predicate(x) ? updater(x) : x)
}

export const insertAfterIndex = <T>(items: T[], index: number, newItem: T) => {
  const position = Math.max(index, -1) + 1
  return [
    ...items.slice(0, position),
    newItem,
    ...items.slice(position)]
}

export const removeAtIndex = <T>(items: T[], index: number) => {
  return items.filter((_, i) => i !== index)
}

export const addDefaultIfEmpty = <T>(items: T[], emptyDefault: T) => {
  if (items.length === 0) {
    items.push(emptyDefault)
  }
  return items
}

export const countDistinct = <T>(items: T[]): number => {
  return new Set(items).size
}
